import React, { Component } from "react";
import "./gridstyles.css";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { adminLabels } from "../../../redux/constant/admin-label-constant";
import { hasPermission } from "helper/hasPermission";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";
import { confirmAlert } from "react-confirm-alert";
//import defaultImage from "assets/img/default.jpg";
import Image from "react-graceful-image";

class TagsGridLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.tagProp,
            tagObject: this.props.tagObject
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.tag !== prevState.tag) {
            this.props.returnState({
                formData: this.state.tagObject
            });
        }
    }

    deleteConfirmListItem = id => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete
                        typeName="Tag Layout"
                        onClosePro={onClose}
                        deleteType={() => this.props.onDeleteListItem(id)}
                    />
                );
            }
        });
    };

    render() {
        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= this.props.fullProps.pages; i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <li
                    className={
                        this.props.fullProps.current_page === number
                            ? "active-page"
                            : ""
                    }
                    key={number}
                    id={number}
                    onClick={
                        this.props.fullProps.current_page !== number
                            ? this.props.onhandlePaginationClick
                            : null
                    }
                >
                    {number}
                </li>
            );
        });
        //console.log('________________________')
        return (
            <div className="row">
                {this.props.tagsData.map((row, index) => {
                    return (
                        <div className="col-sm-3" key={index}>
                            <div className="card-badge">
                                <div
                                    className="card-header"
                                    style={{ paddingRight: "0px" }}
                                >
                                    {row.title}

                                    <div style={{ float: "right" }}>
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={
                                                <Popover id="tooltip">
                                                    {hasPermission(
                                                        "manage-brand-tag-layouts"
                                                    )
                                                        ? `Edit TagLayout`
                                                        : adminLabels.DONT_ALLOW}
                                                </Popover>
                                            }
                                        >
                                            <span>
                                                {hasPermission(
                                                    "manage-brand-tag-layouts"
                                                ) && (
                                                        <button
                                                            type="button"
                                                            className="editIcon orderDetailsAction "
                                                            onClick={() =>
                                                                this.props.editTagLayoutCall(
                                                                    row.id
                                                                )
                                                            }
                                                        >
                                                            &nbsp;
                                                        </button>
                                                    )}
                                                {!hasPermission(
                                                    "manage-brand-tag-layouts"
                                                ) && (
                                                        <button
                                                            type="button"
                                                            className="editIcon orderDetailsAction button_disabled"
                                                        >
                                                            &nbsp;
                                                        </button>
                                                    )}
                                            </span>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={
                                                <Popover id="tooltip">
                                                    {hasPermission(
                                                        "manage-brand-tag-layouts"
                                                    )
                                                        ? `Delete TagLayout`
                                                        : adminLabels.DONT_ALLOW}
                                                </Popover>
                                            }
                                        >
                                            <span>
                                                {hasPermission(
                                                    "manage-brand-tag-layouts"
                                                ) && (
                                                        <button
                                                            type="button"
                                                            className="deleteIcon orderDetailsAction"
                                                            onClick={() =>
                                                                this.deleteConfirmListItem(
                                                                    row.id
                                                                )
                                                            }
                                                        >
                                                            &nbsp;
                                                        </button>
                                                    )}
                                                {!hasPermission(
                                                    "manage-brand-tag-layouts"
                                                ) && (
                                                        <button
                                                            type="button"
                                                            className="deleteIcon orderDetailsAction button_disabled"
                                                        >
                                                            &nbsp;
                                                        </button>
                                                    )}
                                            </span>
                                        </OverlayTrigger>
                                    </div>
                                </div>

                                <Image
                                    src={process.env.REACT_APP_S3_THUMBNAIL_PATH + row.path}
                                    style={{
                                        maxWidth: "280",
                                        maxHeight: "250",
                                        margin: "0 auto"
                                    }}
                                    alt="image"
                                    retry={{ count: 10, delay: 2 }}
                                    placeholderColor="#ccc"
                                />

                                <div className="card-body">
                                    <ul
                                        className="list-group list-group-flush"
                                        style={{ marginBottom: "0px" }}
                                    >
                                        <li className="list-group-item borderless">
                                            <i>Bar Code:</i>{" "}
                                            <small>{row.barcode}</small>
                                        </li>
                                        <li className="list-group-item borderless">
                                            <i>Brand:</i>{" "}
                                            <small>{row.brand}</small>
                                        </li>
                                        <li className="list-group-item borderless">
                                            <i>Description:</i>{" "}
                                            <small>{row.description}</small>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    );
                })}

                <div className="col-lg-12">
                    <div
                        className="col-lg-12"
                        style={{
                            display: "table",
                            margin: "0 auto",
                            width: "auto",
                            float: "none"
                        }}
                    >
                        <ul id="page-numbers">{renderPageNumbers}</ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default TagsGridLayout;



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/TagsGridLayout.jsx